const GET_REPORT_VERSIONS_SUCCESS = 'GET_REPORT_VERSIONS_SUCCESS';
const GET_REPORTS_DATA_SUCCESS = 'GET_REPORTS_DATA_SUCCESS';
const GET_PUBLISHED_REPORT_VERSION_SUCCESS = 'GET_PUBLISHED_REPORT_VERSION_SUCCESS'

export {
  GET_REPORT_VERSIONS_SUCCESS,
  GET_REPORTS_DATA_SUCCESS,
  GET_PUBLISHED_REPORT_VERSION_SUCCESS
}
